// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1-4kR","errorLogs":"EditorFooter_errorLogs__3XFaF"};